"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIN_VALUE = exports.MAX_VALUE = void 0;
exports.MAX_VALUE = 255; // 8-bits max is 255.
exports.MIN_VALUE = 0;
